import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import React from 'react';
import { useTranslation } from 'react-i18next';
function WayPoint({
  isArrival,
  bikeStationsMap,
  route: {
    wayPoints,
    sections
  },
  sectionIndex
}) {
  const {
    t
  } = useTranslation();
  const section = sections[sectionIndex];
  const departure = wayPoints[sectionIndex];
  const arrival = wayPoints[wayPoints.length - 1];
  const prevSection = sections[sectionIndex - 1];
  const bikeStations = 'bikeStations' in section && section.bikeStations || undefined;
  const departureBikeStation = bikeStations ? bikeStations.from : prevSection && 'bikeStations' in prevSection && prevSection.bikeStations?.to || undefined;
  return /*#__PURE__*/React.createElement(_Box, null, /*#__PURE__*/React.createElement(_Typography, {
    fontSize: "0.875rem",
    fontWeight: 700
  }, isArrival ? arrival.addressDetail?.primaryText : departureBikeStation ? t('commons.routing.roadmap.bike_station_name', {
    name: bikeStationsMap[departureBikeStation.bikeStationId]?.name || ''
  }) : departure.addressDetail?.primaryText), /*#__PURE__*/React.createElement(_Typography, {
    color: "#00000099",
    fontSize: "0.875rem",
    fontWeight: 400
  }, isArrival ? arrival.addressDetail?.secondaryText : departureBikeStation ? departure.address : departure.addressDetail?.secondaryText));
}
export default WayPoint;